export const GOOGLE_PLACES_API_KEY = import.meta.env.VITE_GOOGLE_PLACES_API_KEY ?? '';
export const GOOGLE_MAP_ID = "7fe95aab5ee580e5";